/*
 * @Author: lubiwei
 * @LastEditors: wangshengqiang
 * @Description: 投保结果页，显示支付结果和承保结果，华润经代项目接入横琴传世一号时追加的组件
 */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Button, Loading, Toast } from 'zarm';
import { queryPayStatus } from '@/services'; // import jsBridge from '@/utils/jsBridge';

import { getState } from '@/store';
import imagePaySuccess from '@/assets/images/paySuccess.png';
import imagePayFail from '@/assets/images/payFail.png';
import imagePaying from '@/assets/images/payMent.png';
import './index.less';

const InsuranceResultForHengQin = () => {
  const [payStatus, setPayStatus] = useState('');
  const [payNum, setPayNum] = useState('');
  const [paySuccessDate, setPaySuccessDate] = useState('');
  const orderDetail = getState('orderDetail');
  Loading.show();
  useEffect(() => {
    const params = {
      orderNo: orderDetail.orderNo,
      applicationNo: '13123123',
      // TODO: applicantNo 和 paymentTradeNo 的来源目前不确定，orderDetail应该会有，但具体Path不确定。
      paymentTradeNo: '12312'
    };
    queryPayStatus(params).then(res => {
      const {
        code,
        result,
        message
      } = res;

      if (code === '10000') {
        setPayStatus(result.payStatus);
        setPayNum(result.paymentTradeNo);
        setPaySuccessDate(result.paySuccessDate);
        Loading.hide();
      } else {
        Loading.hide();
        Toast.show({
          concent: message
        });
      }
    }).catch(() => {
      Loading.hide();
      Toast.show({
        concent: '查询失败'
      });
    });
  }, []);

  const payAgain = () => {
    // TODO: 去银行卡录入页
    window.location.href = `${window.location.href.replace(/#page=.*/, '')}#page=8`;
  };

  const closeCurrentPage = () => {// jsBridge.closeWebView();
  };

  const gotoOrderDetail = () => {
    // TODO: 去订单详情页
    window.location.href = `${window.location.origin.replace('-dplatform-h5', '-aquarius-h5')}/index/orderDetail/${'orderId'}`;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "payResult"
  }, payStatus === 'S' && /*#__PURE__*/React.createElement("div", {
    className: "paySuccess"
  }, /*#__PURE__*/React.createElement("img", {
    src: imagePaySuccess,
    alt: "",
    className: "payStatuImg"
  }), /*#__PURE__*/React.createElement("p", {
    className: "payStatus"
  }, "\u606D\u559C\u60A8\u6295\u4FDD\u6210\u529F\uFF01"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "payNum"
  }, /*#__PURE__*/React.createElement("div", {
    className: "payScuTitle"
  }, "\u4FDD\u5355\u53F7"), /*#__PURE__*/React.createElement("div", null, "P9083829920003900")), /*#__PURE__*/React.createElement("p", {
    className: "payDate"
  }, /*#__PURE__*/React.createElement("div", {
    className: "payScuTitle"
  }, "\u8BA2\u5355\u652F\u4ED8\u65F6\u95F4"), /*#__PURE__*/React.createElement("div", null, moment(new Date()).format('YYYY年MM月DD日 HH:mm:ss')))), /*#__PURE__*/React.createElement("div", {
    className: "payResultBtn"
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    onClick: closeCurrentPage,
    className: "goback"
  }, "\u5173\u95ED"), !window._IS_IN_APP ? /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    onClick: gotoOrderDetail,
    className: "checkOrder"
  }, "\u67E5\u770B\u8BA2\u5355") : null)), payStatus === 'R' && /*#__PURE__*/React.createElement("div", {
    className: "payMent"
  }, /*#__PURE__*/React.createElement("img", {
    src: imagePaying,
    alt: "",
    className: "payStatuImg"
  }), /*#__PURE__*/React.createElement("p", null, "\u554A\u54E6\uFF5E\u652F\u4ED8\u9047\u5230\u95EE\u9898\uFF0C\u8BF7\u6838\u5B9E\u540E\uFF0C\u518D\u8FDB\u884C\u652F\u4ED8"), /*#__PURE__*/React.createElement("p", {
    className: "promptInfo"
  }, "\u60A8\u7684\u8D26\u6237\u4F59\u989D\u4E0D\u8DB3"), /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    onClick: payAgain,
    className: "payAgain"
  }, "\u91CD\u65B0\u652F\u4ED8")));
};

export default InsuranceResultForHengQin;